import React, { useContext, useEffect, useState, useCallback } from "react";
import * as S from "./UsersStyle";
import ModalCriar from "./ModalCriar/ModalCriar";
import ModalUser from "./ModalUser";
import ModalPermissionsViewer from "./ModalPermissionsViewer";
import Loading from "../Loader";
import { AuthContext } from "../../Context/AuthContext";
import { adminService } from "../../Services/adminService";
import { FaPlus, FaTrash, FaEdit } from "react-icons/fa";
import adminAxiosInstance from "../../Services/api/adminAxiosInstance";

export default function Users() {
  const { authState } = useContext(AuthContext);
  const [users, setUsers] = useState([]);
  const [search, setSearch] = useState("");
  const [modalAddShow, setModalAddShow] = useState(false);
  const [modalEditUser, setModalEditUser] = useState(null);
  const [viewingPermissionsFor, setViewingPermissionsFor] = useState(null);
  const [loading, setLoading] = useState(true);

  const getUsers = useCallback(async () => {
    setLoading(true);
    try {
      const res = await adminAxiosInstance.get("admin");
      setUsers(res.data);
    } catch (error) {
      console.error("Erro ao buscar usuários:", error);
      alert("Não foi possível carregar a lista de usuários.");
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    getUsers();
  }, [getUsers]);

  const filteredUsers =
    search.length > 0
      ? users.filter((user) =>
          user.name.toLowerCase().includes(search.toLowerCase())
        )
      : users;

  const formatCPF = (cpf) => {
    if (!cpf) return "N/A";
    cpf = cpf.replace(/\D/g, "");
    if (cpf.length !== 11) return cpf;
    return cpf.replace(/(\d{3})(\d{3})(\d{3})(\d{2})/, "$1.$2.$3-$4");
  };

  const handleDelete = async (userToDelete) => {
    if (userToDelete.id === authState.admin?.id) {
      alert("Você não pode excluir sua própria conta.");
      return;
    }

    if (
      window.confirm(
        `Tem certeza que deseja excluir o usuário "${userToDelete.name}"?`
      )
    ) {
      setLoading(true);
      try {
        await adminService.deleteAdmin(userToDelete.id);
        alert("Usuário excluído com sucesso.");
        getUsers();
      } catch (err) {
        alert(
          `Erro ao excluir usuário: ${
            err.response?.data?.message || err.message
          }`
        );
      } finally {
        setLoading(false);
      }
    }
  };

  return (
    <S.UsersContainer>
      <Loading load={loading} />

      {modalAddShow && (
        <ModalCriar
          onClose={() => setModalAddShow(false)}
          onUserCreated={() => {
            setModalAddShow(false);
            getUsers();
          }}
        />
      )}
      {modalEditUser && (
        <ModalUser
          userData={modalEditUser}
          onClose={() => setModalEditUser(null)}
          onUserUpdated={() => {
            setModalEditUser(null);
            getUsers();
          }}
        />
      )}
      {viewingPermissionsFor && (
        <ModalPermissionsViewer
          user={viewingPermissionsFor}
          onClose={() => setViewingPermissionsFor(null)}
        />
      )}

      <S.ContentBox>
        <S.UsersFirstContent>
          <S.AreaTitle>Usuários do Sistema</S.AreaTitle>
          <S.AddClient onClick={() => setModalAddShow(true)}>
            <FaPlus /> Adicionar Usuário
          </S.AddClient>
        </S.UsersFirstContent>

        <S.Users>
          <S.SearchBar>
            <input
              value={search}
              onChange={(e) => setSearch(e.target.value)}
              type="text"
              placeholder="Pesquisar por nome..."
            />
          </S.SearchBar>

          <S.TableContainer>
            <S.Table>
              <S.TableHeader>
                <S.TableRow>
                  <S.TableHeaderCell>Nome</S.TableHeaderCell>
                  <S.TableHeaderCell>CPF</S.TableHeaderCell>
                  <S.TableHeaderCell>E-mail</S.TableHeaderCell>
                  <S.TableHeaderCell style={{ textAlign: "center" }}>
                    Permissões
                  </S.TableHeaderCell>
                  <S.TableHeaderCell>Ações</S.TableHeaderCell>
                </S.TableRow>
              </S.TableHeader>
              <S.TableBody>
                {filteredUsers.map((user) => (
                  <S.TableRow key={user.id}>
                    <S.TableCell>{user.name}</S.TableCell>
                    <S.TableCell>{formatCPF(user.cpf)}</S.TableCell>
                    <S.TableCell>{user.email}</S.TableCell>
                    <S.TableCell style={{ textAlign: "center" }}>
                      <S.ViewPermissionsButton
                        onClick={() => setViewingPermissionsFor(user)}
                      >
                        Ver Permissões
                      </S.ViewPermissionsButton>
                    </S.TableCell>
                    <S.TableCell>
                      <S.OptionsGroup>
                        <button
                          onClick={() => setModalEditUser(user)}
                          title="Editar Permissões"
                        >
                          <FaEdit />
                        </button>
                        <button
                          className="delete-btn"
                          onClick={() => handleDelete(user)}
                          title="Excluir Usuário"
                        >
                          <FaTrash />
                        </button>
                      </S.OptionsGroup>
                    </S.TableCell>
                  </S.TableRow>
                ))}
              </S.TableBody>
            </S.Table>
          </S.TableContainer>
        </S.Users>
      </S.ContentBox>
    </S.UsersContainer>
  );
}
